import { createTranslations } from '@npco/utils-translations'

export const translations = createTranslations({
  errorTitle: 'Cards failed to load',
  errorDescription:
    'An error occurred while loading assigned Cards. Please try again and {contactZellerSupport} if the problem persists.',
})
